const appConfig = {
	width: 960,
	height: 1706,
	antialias: false,
	backgroundColor: 0x140c1c,
	screenShakeIntensity: 25,
	level: {
		xLimit: 4,
		yLimit: 6,
	},
} as const
export default appConfig
